var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-tool-tip" },
    [
      _c("b-icon", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.bottom",
            value: { content: this.content, container: false },
            expression: "{ content: this.content, container: false }",
            modifiers: { bottom: true },
          },
        ],
        staticClass: "info-icon ml-2",
        attrs: { icon: "info-circle-fill" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }